import { render, staticRenderFns } from "./loan.vue?vue&type=template&id=c6ad1d88&scoped=true&"
import script from "./loan.vue?vue&type=script&lang=js&"
export * from "./loan.vue?vue&type=script&lang=js&"
import style0 from "./loan.vue?vue&type=style&index=0&id=c6ad1d88&scoped=true&lang=css&"
import style1 from "./loan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ad1d88",
  null
  
)

export default component.exports